export default __webpack_public_path__ + "img/5fd2c33ca7f147e249f07129e7422809.png";